import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Logo from './Logo';
import ThemeToggle from './ThemeToggle';
import { CONTACT_PATH, LEGAL_PATHS, OFFERING_PATH } from '../legal/company';
import { useAuth } from '../context/AuthContext';

export const PUBLIC_NAV: { label: string; path: string }[] = [
  { label: 'What you get', path: OFFERING_PATH },
  { label: 'Terms', path: LEGAL_PATHS.terms },
  { label: 'Privacy', path: LEGAL_PATHS.privacy },
  { label: 'Cookies', path: LEGAL_PATHS.cookies },
  { label: 'Refunds', path: LEGAL_PATHS.refunds },
  { label: 'Contact', path: CONTACT_PATH },
];

const PublicTopNav: React.FC<{ activePath: string }> = ({ activePath }) => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  return (
    <nav className="nova-nav">
      <div className="nova-nav-inner">
        <Link to="/" aria-label="OnTheWeb home">
          <Logo />
        </Link>
        <div className="hidden lg:flex items-center gap-1 ml-auto mr-4">
          {PUBLIC_NAV.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`text-sm px-3 py-1.5 rounded-md transition-all duration-300 ${
                item.path === activePath
                  ? 'text-nova-text bg-white/10'
                  : 'text-nova-text2 hover:text-nova-text hover:bg-white/5'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </div>
        <div className="flex items-center gap-2 sm:gap-3 ml-auto lg:ml-0">
          <ThemeToggle />
          {isAuthenticated ? (
            <button onClick={() => navigate('/dashboard')} className="btn-primary">
              Dashboard
            </button>
          ) : (
            <button onClick={() => navigate('/login')} className="btn-primary">
              Get started
            </button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default PublicTopNav;
